<template>
    <!--定点投放--投放统计--投放概览/扫码概览 对话框 -->
    <el-dialog :visible.sync="show" :before-close="closeDialog" width="80%" top="5vh" append-to-body>
        <!-- 高德地图功能组件 -->
        <div>
            <div style="border: 1px solid #ccc; width: 99%; padding: 10px; margin-bottom: 10px" class="handle-box">
                <div>
                    <!-- 投放统计概览查询条件 -->
                    <el-row class="head-search">
                        <el-col :span="12">
                            <span class="title">渠道码名称: </span>
                            <el-select
                                v-model="search_data.promotion_qr_code"
                                placeholder="请选择渠道码名称"
                                style="width: 330px"
                                clearable
                                filterable
                                :disabled="isDisabled"
                                @change="getOverView"
                            >
                                <el-option
                                    v-for="(item, index) in promotionLists"
                                    :key="index"
                                    :label="item.name"
                                    :value="item.promotion_qr_code"
                                >
                                </el-option>
                            </el-select>
                        </el-col>
                        <el-col :span="12">
                            <span class="title">渠道类目: </span>
                            <el-select
                                v-model="search_data.promotion_category_code"
                                :disabled="isDisabled"
                                clearable
                                filterable
                                placeholder="请选择渠道类目"
                                style="width: 330px"
                                @change="getOverView"
                            >
                                <el-option
                                    v-for="(item, index) in categoryLists"
                                    :key="index"
                                    :label="item.name"
                                    :value="item.promotion_category_code"
                                >
                                </el-option>
                            </el-select>
                        </el-col>
                    </el-row>
                    <el-row class="head-search">
                        <el-col :span="12">
                            <span class="title">区域: </span>
                            <el-select
                                clearable
                                filterable
                                v-model="search_data.district"
                                placeholder="请选择区域"
                                style="width: 330px"
                                @change="getOverView"
                            >
                                <el-option v-for="(item, index) in cityArray" :key="index" :label="item" :value="item"> </el-option>
                            </el-select> </el-col
                    ></el-row>
                    <el-button type="primary"  @click="getOverView">搜索</el-button>

                    <el-button type="primary" icon="el-icon-refresh-right" @click="refresh">重置查询条件</el-button>
                </div>
            </div>

            <!-- 地图容器 -->
            <div id="container_details" v-if="show"></div>
        </div>
    </el-dialog>
</template>

<script>
var _this, map;
import axios from 'axios'; // AJAX封装类
import { config } from '@/utils/config'; //配置

export default {
    props: {
        isShow: Boolean,
        data: {}
    },
    watch: {
        isShow(newData, oldData) {
            _this.show = true;
            _this.promotionQRLists(); //获取渠道码名称
            _this.promotionCategoryLists(); //获取类目

            _this.getCityCode(); // 获取adcode 然后拿着adcode获取高德地图的区域

            if (_this.data.promotion_qr_code == '' || _this.data.promotion_qr_code == undefined) {
                // 投放统计模块，投放概览进来的
                _this.isDisabled = false;
            } else {
                _this.isDisabled = true;

                _this.search_data.promotion_category_code = _this.data.promotion_category_code;
                _this.search_data.promotion_qr_code = _this.data.promotion_qr_code;
                _this.search_data.district = _this.data.district;
            }


            _this.$nextTick(() => {
                _this.getMap();
            });
        }
    },
    data() {
        return {
            viewMarkerList: [],
            viewMarker: [],
            show: false,
            driverMarks_status: [],
            isDisabled: false,
            promotionLists: [],
            categoryLists: [],
            overViewArray: [],
            map_center_lng: '',
            map_center_lat: '',
            cityArray: [], // 区域数组
            adcode: '',
            search_data: {
                promotion_category_code: '',
                promotion_qr_code: '',
                district: ''
            },
            search_data_child: {
                page: 1,
                limit: 10,
                name: '',
                promotion_qr_code: '',
                promotion_category_code: ''
            },
            search_data_list: {
                // 投放类目查询
                page: 1,
                limit: 10
            },
            search_rules: {
                page: {
                    placeholder: '页码',
                    rules: {
                        required: true,
                        message: '页码需要大于0',
                        regulation: 'gt',
                        rulesData: 0
                    }
                },
                limit: {
                    placeholder: '每页个数',
                    rules: {
                        required: true,
                        message: '每页个数需在1-51之内',
                        regulation: 'between',
                        rulesData: [1, 51]
                    }
                }
            }
        };
    },
    created() {
        _this = this;
    },

    methods: {
        // 文本标记点击事件

        refresh() {
            if (_this.data.promotion_qr_code == '' || _this.data.promotion_qr_code == undefined) {
                _this.search_data = {
                    promotion_category_code: '',
                    promotion_qr_code: '',
                    district: ''
                };
            } else {
                _this.search_data.district = '';
            }
        },
        // 在地图上添加文本标记
       addText(element) {
        _this.viewMarker[element.scan_time_stamp] = new TMap.MultiLabel({
            map: map,
            styles: {
                "viewMarkerStyle": new TMap.LabelStyle({
                    size: 12, // 文字大小属性
                    padding: "10px 15px",
                    color: "#fff",
                    borderRadius: "4px",
                    backgroundColor: element.promotion_category_color,
                })
            },
            geometries: [{
                "id": element.scan_time_stamp,
                "styleId": "viewMarkerStyle",
                "position": new TMap.LatLng(element.lat, element.lng),
                "content": element.promotion_qr_name
            }]
            });
            // 点击文本标记打开信息窗体
            var position = new TMap.LatLng(element.lat, element.lng);
            _this.viewMarker[element.scan_time_stamp].on("click", function (e) {
                // 创建信息窗体
                var infoWindow = new TMap.InfoWindow({
                map: map,
                position: position,
                content:
                    '<div style="background-color:white;padding: 5px;">' +
                    element.name +
                    "</div>" +
                    '<div style="background-color:white;padding: 5px;">' +
                    element.phone +
                    "</div>" +
                    '<div style="background-color:white;padding: 5px;">' +
                    element.scan_time +
                    "</div>", // 信息窗体内容
                offset: { x: 0, y: -30 }
                });
            });
        },
        getCityCode() {
            // axios.defaults.baseURL = config.axios_normalURL;
            _this
                .$post('/city/getCityCode', {
                    city_tag: localStorage.getItem('city_tag')
                },{},'normal')
                .then((res) => {
                    // axios.defaults.baseURL = config.axios_baseURL; //请求base url

                    _this.adcode = res.data.area_code;
                    if (res.data.area_code.length == 4) {
                        _this.adcode += '00';
                    }

                    _this.getDistrict(); // 获取区域
                })
                .catch((err) => {});
            // axios.defaults.baseURL = config.axios_baseURL; //请求base url
        },

        // 获取行政区域
        getDistrict() {
            console.log(_this.adcode,'_this.adcode');
            _this.cityArray = [];
            var opts = {
                id: _this.adcode, //返回下一级行政区
            };

            var district = new TMap.service.District(); //注意：需要使用插件同步下发功能才能这样直接使用

            district.getChildren(opts).then((result) => {
                console.log(result,'result');
                if (result.status == "0") {
                let districtListArr = result.result[0];
                for (let i = 0; i < districtListArr.length; i++) {
                    _this.cityArray.push(districtListArr[i].fullname);
                }

                _this.map_center_lng = result.result[0][0].location.lng;
                _this.map_center_lat = result.result[0][0].location.lat;

                map.setCenter(new TMap.LatLng(_this.map_center_lat, _this.map_center_lng)); // 设置中心点
                }
            });
        },
        // 获取渠道类目

        promotionCategoryLists() {
            _this
                .$post('/promotion/promotionCategoryLists', _this.search_data_list)
                .then((res) => {
                    for (let i = 0; i < res.data.length; i++) {
                        _this.categoryLists.push({ name: res.data[i].name, promotion_category_code: res.data[i].promotion_category_code });
                    }

                    // 如果一次接口请求数据少于全部数据就再次请求
                    console.log(_this.search_data_list.page * _this.search_data_list.limit,'_this.search_data_list.page * _this.search_data_list.limit');
                    if (_this.search_data_list.page * _this.search_data_list.limit < res.count) {
                        console.log(11111111111);
                        _this.search_data_list.page+=1;
                        _this.promotionCategoryLists();
                    }

                })
                .catch((err) => {});
        },
        // 获取渠道名称和编码
        promotionQRLists() {
            _this
                .$post('/promotion/promotionQRLists', _this.search_data_child, _this.search_rules)
                .then((res) => {
                    for (let i = 0; i < res.data.length; i++) {
                        _this.promotionLists.push({ name: res.data[i].name, promotion_qr_code: res.data[i].promotion_qr_code });
                    }

                    // 如果一次接口请求数据少于全部数据就再次请求
                    if (_this.search_data_child.page * _this.search_data_child.limit < res.count) {
                        console.log(12222222222);
                        _this.search_data_child.page+=1;
                        _this.promotionQRLists();
                    }


                })
                .catch((err) => {});
        },
        // 清除文本标记
        clearMarker() {
            _this.viewMarkerList.map(item => {
                if(_this.viewMarker[item.scan_time_stamp]){
                    _this.viewMarker[item.scan_time_stamp].remove(item.scan_time_stamp)
                }
            })

        },
        getOverView() {

            _this
                .$post('/promotion/getOverView', _this.search_data)
                .then((res) => {
                    _this.overViewArray = res.data;


                    // _this.overViewArray = [
                    //     {
                    //         promotion_qr_code: 'PRQR655EFB588093D87',
                    //         name: 'null',
                    //         promotion_qr_name: '渠道码名称',
                    //         district: null,
                    //         lat: '43.828471',
                    //         lng: '125.176229',
                    //         promotion_category_code: '',
                    //         promotion_category_color: '#FA4705'
                    //     },
                    //     {
                    //         promotion_qr_code: 'PRQR655EFB588093D87',
                    //         name: 'null',
                    //         promotion_qr_name: '渠道码名称',
                    //         district: null,
                    //         lat: '43.828471',
                    //         lng: '125.176229',
                    //         promotion_category_code: '',
                    //         promotion_category_color: '#FA4705'
                    //     }
                    //
                    // ];

                    // map.setMap(null);
                    // 切换查询条件的时候清空文本标记然后根据查询数据重新添加文本标记
                    _this.clearMarker();
                    _this.viewMarkerList = res.data;
                    // 在地图上添加文本标记
                    // 如果接口返回数据则添加文本标记

                    if (res.data.length > 0) {
                        _this.overViewArray.forEach((element) => {
                            _this.addText(element);

                        });
                    }
                })
                .catch((err) => {});
        },
        getMap() {

            // 地图初始化
             map = new TMap.Map("container_details", {
                zoom: 11.43,
                pitch: 55,
                rotation: 0,
                showLabel: true,
            });



            _this.getOverView(); // 获取文本标记数据

            // viewMarker.on('click', function (e) {
            //     console.log('文本点击事件');
            //     // 创建信息窗体
            //     var infoWindow = new AMap.InfoWindow({
            //         content: '<p>信息窗体内容</p>', // 信息窗体内容
            //         size: new AMap.Size(240, 0), // 信息窗体大小
            //         offset: new AMap.Pixel(0, -30) // 信息窗体偏移位置
            //     });
            //     console.log(infoWindow, 'infoWindow');

            //     // 打开信息窗体
            //     infoWindow.open(map, [e.lnglat.R, e.lnglat.Q]);
            // });

            // AMap.event.addListener(viewMarker, 'click', function () {
            //     console.log('文本标记点击事件放这里不好使，需要放到添加完文本标记的位置');
            // });
        },

        // 关闭方法
        closeDialog() {
            _this.show = false;
            _this.driverMarks_status= [];

            _this.clearMarker();
            _this.isDisabled = false;
            _this.promotionLists = [];
            _this.categoryLists = [];
            _this.overViewArray = [];
            _this.map_center_lng = '';
            _this.map_center_lat = '';
            _this.cityArray = []; // 区域数组
            _this.adcode = '';
            _this.search_data = {
                promotion_category_code: '',
                promotion_qr_code: '',
                district: ''
            };
            _this.search_data_child = {
                page: 1,
                limit: 10,
                name: '',
                promotion_qr_code: '',
                promotion_category_code: ''
            };
            _this.search_data_list = {
                // 投放类目查询
                page: 1,
                limit: 10
            };
        }
    }
};
</script>

<style scoped>
#container_details {
    height: 75vh;
    width: 100%;
}
.custom-margin-top {
    margin-top: 50px !important;
}
</style>
<style>
</style>